var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-drawer-item",
    {
      staticClass: "w-drawer-item",
      attrs: { to: _vm.to, disabled: !_vm.canRead },
    },
    [
      _c(
        "w-row",
        { attrs: { "no-margin": "" } },
        [
          _c("app-icon", {
            staticClass: "icon nav-icon",
            attrs: { icon: _vm.icon },
          }),
          _c("span", { staticClass: "text" }, [_vm._v(_vm._s(_vm.text))]),
          _c("w-spacer"),
          !_vm.canRead
            ? _c(
                "span",
                [_c("w-fa", { staticClass: "lock", attrs: { icon: "lock" } })],
                1
              )
            : _vm._e(),
          _vm.newLabel
            ? _c("span", { staticClass: "new" }, [
                _vm._v(_vm._s(_vm.newLabelText || "nieuw")),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }